import ImageLazyLoad from '@/utils/libs/ImageLazyLoad';
import VideoLazyLoad from '@/utils/libs/VideoLazyLoad';

const { Component, lazy, createRef } = require('react');

/**
 * 空闲时加载组件
 * 适用场景：非SSR组件、非动态查询渲染组件，非首屏组件、长列表中的各个组件
 * @param lazy 延迟后两帧渲染
 * @param videoLazy 加载后调用videoLazy方法处理组件内的视频和图片
 * @param imgLazy
 * @param {Array} videoLazyOptions  数组-同@/utils/libs/VideoLazyLoad 方法参数
 * - rootMarginY 上下方向 视口窗的扩张/收缩距离
 * - rootMarginX 左右方向 视口窗的扩张/收缩距离
 * - threshold 视频的可见程度提醒断点
 */
export default class LazyloadOnFrame extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = { shouldRender: false };
    this.ref = createRef(null);
  }

  componentDidMount() {
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(() => {
        if (lazy) {
          return window.requestAnimationFrame(this.shouldRenderCallback);
        }
        this.shouldRenderCallback();
      });
    } else {
      this.shouldRenderCallback();
    }
  }

  shouldRenderCallback = () => {
    const { videoLazy, imgLazy, videoLazyOptions } = this.props;
    this.setState({ shouldRender: true }, () => {
      setTimeout(() => {
        if (videoLazy) {
          if (videoLazyOptions) {
            if (Array.isArray(videoLazyOptions)) {
              const _videoLazyOptions = [
                videoLazyOptions[0],
                videoLazyOptions[1],
                videoLazyOptions[2],
                this.ref.current,
              ];
              VideoLazyLoad(..._videoLazyOptions);
            } else {
              console.error('LazyloadOnFrame videoLazyOptions 接收的参数不是数组');
              VideoLazyLoad(500, undefined, undefined, this.ref.current);
            }
          } else {
            VideoLazyLoad(500, undefined, undefined, this.ref.current);
          }
          ImageLazyLoad(500, this.ref.current);
        }

        if (imgLazy) {
          ImageLazyLoad(500, this.ref.current);
        }
      }, 0);
    });
  };

  render() {
    return this.state.shouldRender ? (
      this.props.videoLazy ? (
        <div ref={this.ref}>{this.props.children}</div>
      ) : (
        this.props.children
      )
    ) : (
      <div ref={this.ref} />
    );
  }
}
